import { useNavigate, useParams } from 'react-router-dom'
import AsignacionForm from '@/features/almacen/components/AsignacionForm'
import type { AsignacionFormPayload } from '@/features/almacen/components/AsignacionForm'
import { devolverHerramienta } from '@/features/almacen/api/movimientos.api'

/**
 * Devolución de una herramienta.
 *
 * Sirve para las dos entradas: con id en la ruta (desde el listado de
 * asignación) y sin id (desde Devolución, donde la herramienta se elige en el
 * formulario).
 */
const DevolverPage = ({
  generica = false,
  volverA = '/almacen/asignacion',
}: {
  generica?: boolean
  volverA?: string
}) => {
  const navigate = useNavigate()
  const { id = '' } = useParams<{ id: string }>()
  const destino = generica ? '/almacen/devolucion' : volverA

  const guardar = async (payload: AsignacionFormPayload) => {
    await devolverHerramienta(generica ? payload.herramienta : id, {
      resultingStatus: payload.resultingStatus ?? 'good',
      warehouseId:     payload.warehouseId,
      cycleUsageHours: payload.cycleUsageHours,
      notes:           payload.notes,
      evidenceUrl1:    payload.evidenceUrl1,
      evidenceUrl2:    payload.evidenceUrl2,
      evidenceUrl3:    payload.evidenceUrl3,
    })
    navigate(destino)
  }

  return (
    <AsignacionForm
      mode="devolver"
      toolId={generica ? '' : id}
      onBack={() => navigate(destino)}
      onSubmit={guardar}
    />
  )
}

export default DevolverPage
